export const FULL_DASH_ARRAY = 534;

export const calculateProgress = (seconds: number): number => seconds / 60;

export interface Milestone {
  emoji: string;
  text: string;
  color: string;
}

export const getMilestone = (minutes: number): Milestone | null => {
  if (minutes >= 25) return { emoji: '🔥', text: 'On fire!', color: '#F56565' };
  if (minutes >= 15) return { emoji: '⭐', text: 'Deep focus!', color: '#9F7AEA' };
  if (minutes >= 5) return { emoji: '✓', text: 'Great start!', color: '#48BB78' };
  return null;
};

/**
 * Formats a raw secondsRemaining number into "M:SS" display string.
 * e.g. 125 → "2:05", 60 → "1:00", 9 → "0:09"
 */
export const formatCountdown = (secondsRemaining: number): string => {
  const m = Math.floor(secondsRemaining / 60);
  const s = secondsRemaining % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
};
